import { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { AgentDto, ToolDto } from '@shared/services/apiService/apiService';
import {
  ExpandedAgentIdleState,
  ExpandedAgentIdleStateDraft,
} from '@features/Admin/Agent/model/idleState';
import { AgentToolsFormValue } from '@features/Admin/Agent/model/types';
import { mapAgentToolsToAdvancedSettingsSnapshot } from './agent-advanced-settings-form-mapper';
import { SetExpandedSettings } from './types';

export const useAdvancedSettingsFormHydration = ({
  open,
  agent,
  agentNonMcpTools,
  isLoadingAgentTools,
  formMethods,
  hydrateIdleState,
  setExpandedSettings,
}: {
  open: boolean;
  agent: AgentDto;
  agentNonMcpTools: ToolDto[];
  isLoadingAgentTools: boolean;
  formMethods: UseFormReturn<AgentToolsFormValue>;
  hydrateIdleState: (draft: ExpandedAgentIdleStateDraft) => void;
  setExpandedSettings: SetExpandedSettings;
}) => {
  const { reset } = formMethods;
  const [hydratedAgentId, setHydratedAgentId] = useState<string | null>(null);

  useEffect(() => {
    if (!open || !agent.id || isLoadingAgentTools) {
      setHydratedAgentId(null);
      return;
    }

    if (agent.id && !isLoadingAgentTools) {
      const snapshot = mapAgentToolsToAdvancedSettingsSnapshot(
        agent.id,
        agent.idleState as ExpandedAgentIdleState,
        agentNonMcpTools,
      );

      setExpandedSettings(snapshot.expandedSettings);
      reset(snapshot.formValues);
      hydrateIdleState(snapshot.idleStateDraft);
      setHydratedAgentId(agent.id);
    }
  }, [
    agent.id,
    agentNonMcpTools,
    hydrateIdleState,
    isLoadingAgentTools,
    open,
    reset,
    setExpandedSettings,
  ]);

  return {
    isHydrated: open && !isLoadingAgentTools && hydratedAgentId === agent.id,
  };
};
